<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.cons{
  display: none;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .effect-lists{
    justify-content: flex-start!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/img/产品及服务/基因调控/基因编辑/banner.png" class="img-fluid">-->
<!--      <div class="info">-->

<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>sgRNA合成</h1>
      <h2 class="mt10">sgRNA Synthesis</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="margin-bottom: 20px;">sgRNA（Small Guide RNA），也称为小向导RNA，是CRISPR基因敲除敲入系统中重要的组成部分，早先发现的guide RNA由两部分组成——tracRNA和crRNA，两部分融合表达后，即sgRNA也能很好的行使guide的功能，与Cas9蛋白结合，引导Cas9酶靶向基因组DNA进行剪切。</p>
        <p class="desc">常用的sgRNA以质粒形式转染入细胞，可以将sgRNA和Cas蛋白设计在同一个质粒上，或将sgRNA和Cas蛋白分别设计在不同的质粒上。除非包装成病毒，否则不论哪种方式，都因为质粒片段过大而导致编辑效率太低，并且有更高的脱靶风险。擎科生物采用化学合成的方式直接合成sgRNA全长，拥有类似siRNA的转染效率，且更不容易脱靶。</p>
      </div>
      <div class="container">
        <div class="c-title">产品类型<small>Product type</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="类型">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="长度">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="含量">
            </el-table-column>
            <el-table-column
              prop="method4"
              label="价格（元）">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="container">
        <div class="c-title">使用方法<small>Method of application</small></div>
        <p class="desc" style="margin-bottom: 20px;">可直接用sgRNA或crRNA与Cas蛋白在体外结合为RNA-蛋白复合物（RNP），再利用电转或脂质体转染将RNP直接转入细胞。这样操作的好处的是，相比于RNA、Cas分别进入细胞后再结合，预混合成RNP敲除效率有明显的提高，并且RNP一旦进入细胞，立即就可以发挥作用。</p>
        <img src="@/assets/img/产品及服务/基因调控/sgRNA.png" class="img-fluid con" style="margin-bottom: 20px;">
        <img src="@/assets/img/产品及服务/基因调控/sgRNA.png" class="img-fluid cons" style="margin-bottom: 20px;">
        <p class="desc">一般来说，使用电转化RNP的效率要高于脂质体转化，但是否容易转染，很大程度上和细胞类型是相关的，293T这类工具细胞或者常见的癌细胞系或永生化细胞系，都是可以尝试一下脂质体转化的。而且脂质体转化的RNP用量也远低于电转化。具体转化方法参见电转化系统说明书，脂质体转化可使用Invitrogen™、 Lipofectamine™ 、CRISPRMAX™ 转染试剂。</p>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/bj_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/bj_${item.img}${currentService===index ? '' : ''}.png`" class="img-fluid" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      tableData: [
        {
          method1:'Cas9 sgRNA',
          method2:'100 nt',
          method3:'1.5 nmol',
          method4:'800'
        },
        {
          method1:'Cas12a crRNA',
          method2:'40~44 nt',
          method3:'5 nmol',
          method4:'750'
        }
      ],
      currentType: -1,
      currentService: -1,
      types1: [
        {name: 'sgRNA质粒构建', img: '2', ref: '/products/sgRNA_plasmid_construction'},
        {name: 'sgRNA文库构建', img: '3', ref: '/products/sgRNA_library_construction'},
        {name: 'CRISPRi/CRISPRa服务', img: '4', ref: '/products/CRISPRi_CRISPRa_Applications'}
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/sgRNA_Synthesis.vue